jQuery(function($)
{
    if($(window).width() > 1)
    {
        $("body .m-footer--block .social-media-links").remove().insertAfter($(".m-footer .m-newsletter-form"));
      $(".m-header__mobile m-search-popup").remove().insertBefore($(".m-header__desktop .m-header__right a.m-header__account"));
    }

  if($(window).width() < 767)
    {
        $(".date-animation1").remove().insertBefore($("p.most-brand-para1.dates1"));
        $("img.new-combo-launch1.explore").remove().insertBefore($("p.gift-para"));
        $("img.brand-img1.meet").remove().insertBefore($("p.most-brand-para1.meet1"));

      $("img.about-date-img1").remove().insertAfter($("p.our-date-about-subpara"));
      $("img.celebare-gift-img1").remove().insertAfter($("h2.celebrate-roaring1-titl"));

      $(".ramzan-highest-sec.one img.ramzan-jordanimg").remove().insertAfter($(".ramzan-highest-sec.one h2.ramzan-higtit1"));
      $(".ramzan-highest-sec.two img.ramzan-jordanimg").remove().insertAfter($(".ramzan-highest-sec.two h2.ramzan-higtit1"));
      $(".ramzan-highest-sec.three img.ramzan-jordanimg").remove().insertAfter($(".ramzan-highest-sec.three h2.ramzan-higtit1"));
    }
});
